import { Container } from "@mui/material";
import { DataStoreBreadcrumbs } from "~/components/DataStoreBreadcrumbs";
import { LqsPage } from "~/lqs/layout";
import { ApiKeyEditForm } from "./components/ApiKeyEditForm";

export function EditApiKeyPage() {
  return (
    <LqsPage title="Edit API Key">
      <Container fixed>
        <DataStoreBreadcrumbs />
        <ApiKeyEditForm />
      </Container>
    </LqsPage>
  );
}
